module.exports = __webpack_public_path__ + "img/500m.2c37d0c1.png";